import { novidadeAgendaGoogle } from './2026-10-05-agenda-google';
import { novidadeGoogleEditar } from './2026-11-03-google-editar';
import { novidadeAgendaCores } from './2026-11-03-agenda-cores';
import { novidadeReuniaoLivre } from './2026-11-03-reuniao-livre';
import { novidadeFiliais } from './2026-11-03-filiais';
import { novidadeModosDeCor } from './2026-11-03-modos-de-cor';
import { novidadeContatoPelaConversa } from './2026-11-04-contato-pela-conversa';
import { novidadeAsaas } from './2026-10-05-asaas';
import { novidadeEnviarCobranca } from './2026-10-05-enviar-cobranca';
import { novidadeAgendaServicos } from './2026-10-05-agenda-servicos';
import { novidadeAssistentes } from './2026-10-05-assistentes';
import { novidadeAvisos } from './2026-10-05-avisos';
import { novidadeCadastros } from './2026-10-05-cadastros';
import { novidadeCadastrosContabeis } from './2026-10-05-cadastros-contabeis';
import { novidadeCatalogos } from './2026-10-05-catalogos';
import { novidadeCompras } from './2026-10-05-compras';
import { novidadeConta } from './2026-10-05-conta';
import { novidadeContratos } from './2026-10-05-contratos';
import { novidadeEmails } from './2026-10-05-emails';
import { novidadeConversasEmail } from './2026-10-05-conversas-email';
import { novidadeEquipe } from './2026-10-05-equipe';
import { novidadeFichaPessoas } from './2026-10-05-ficha-pessoas';
import { novidadeFiltros } from './2026-10-05-filtros';
import { novidadeFinanceiro } from './2026-10-05-financeiro';
import { novidadeFuncionarioParceiro } from './2026-10-05-funcionario-parceiro';
import { novidadeHistoricoTelas, novidadeNovaVersao } from './2026-10-05-historico-versao';
import { novidadeIdentidade } from './2026-10-05-identidade';
import { novidadePaginas } from './2026-10-05-paginas';
import { novidadeInicio } from './2026-10-05-inicio';
import { novidadeInicioArremates } from './2026-10-05-inicio-arremates';
import { novidadeLixeira } from './2026-10-05-lixeira';
import { novidadeLixeiraFornecedor } from './2026-10-05-lixeira-fornecedor';
import { novidadeMargem } from './2026-10-05-margem';
import { novidadeCadastrosAbas, novidadeFinanceiroLinha, novidadeIndices, novidadeMenuLateral, novidadeRelatoriosMenu, novidadeVersaoNoAr } from './2026-10-05-navegacao';
import { novidadeNotificacoes } from './2026-10-05-notificacoes';
import { novidadeNotaCredito } from './2026-10-05-nota-credito';
import { novidadeOutraEmpresa } from './2026-10-05-outra-empresa';
import { novidadePortal } from './2026-10-05-portal';
import { novidadeRelatorios } from './2026-10-05-relatorios';
import { novidadeTarefaRegistro } from './2026-10-05-tarefa-registro';
import { novidadeTarefas } from './2026-10-05-tarefas';
import { novidadeVinculos } from './2026-10-05-vinculos';
import { novidadeWhatsAppProvedores } from './2026-10-05-whatsapp-provedores';
import type { Novidade } from './tipos';

export type { Novidade } from './tipos';

/**
 * Catálogo de novidades, da mais nova para a mais antiga (ordem de entrega). Entrada nova vai no PR do recurso. Fase 2 (W14):
 * as entregas que ficaram sem novidade (W1 Início, W4 conta, W5 Cadastros, W6 catálogos e W7 Financeiro) entraram juntas.
 * W17 (K1): W16 (vínculos), W14 (lixeira, importadores e Contas), W13 (Relatórios) e W8 (Compras e modo de operação).
 * W20: o cadastro de outra empresa nas listas e os nomes no chat no modo discreto.
 * W21 (K7 e K13): margem por serviço e os arremates do Início, no topo.
 * W23: o funcionário ligado a um fornecedor do Cadastros (K10) e "Criar tarefa" a partir de qualquer registro (K11).
 * W24 (K9): cadastros contábeis e baixa (investimento e poupança, sintética, forma de pagamento, estorno da baixa), no topo.
 * W28: cobrança pelo Asaas (automática, baixa com tarifa, estorno e cancelamento).
 * W29: "Enviar cobrança agora" na ficha da fatura.
 * W30: WhatsApp com três provedores (API oficial, Baileys e whatsmeow).
 * W32: as cores da Malgo como padrão, o login com a foto do farol e a saída com despedida, no topo.
 * W34: aplicar nota de crédito em fatura (compensação sem caixa) e desfazer, no topo.
 * W33: seletor de período em abas, subtítulo em cada página e o cartão do Resend com o envio pela plataforma, no topo.
 * W31: navegação e menus (menu lateral e Notificações, Índices, Cadastros em cinco abas e serviços contratados, Financeiro
 * numa linha, Relatórios no menu lateral e a correção da Versão no ar), no topo.
 * Portal do Cliente (Onda 1): o lado da equipe do portal, no topo.
 * W37 e W39: a aba Histórico telas do Painel admin e o aviso "Nova versão disponível", no topo.
 * W36: os filtros das listas do Financeiro e de Compras comparados com o antigo, no topo.
 * Cada novidade tem a aula de texto no curso "Novidades do MalgoOS" (`modules/treinamento/src/novidades-aulas.generated.ts`,
 * gerado deste catálogo por `pnpm novidades:gerar`; o `pnpm lint` falha se estiver desatualizado).
 */
export const NOVIDADES: readonly Novidade[] = [
  // Ficha 2026-11-03: card da agenda com a cor de cada pessoa.
  novidadeAgendaCores,
  // Ficha 2026-11-03: formulário de reunião igual ao do Google Agenda.
  novidadeReuniaoLivre,
  novidadeFiliais,
  novidadeGoogleEditar,
  novidadeModosDeCor,
  novidadeContatoPelaConversa,
  // Fase 2 (W39): aviso "Nova versão disponível" com a tela aberta durante uma publicação.
  novidadeNovaVersao,
  // Fase 2 (W37): o comparativo "antes e depois" das telas no Painel admin.
  novidadeHistoricoTelas,
  // Fase 2 (W36): filtros das listas (Contas, Movimentações, Compras e Plano de contas).
  novidadeFiltros,
  // Fase 2 (W34): aplicar nota de crédito em fatura.
  novidadeNotaCredito,
  // Fase 2 (W33): páginas (período em abas, subtítulos e o Resend pela plataforma).
  novidadePaginas,
  // Fase 2 (W32): identidade visual do ERP antigo (cores, login e saída).
  novidadeIdentidade,
  // Fase 2 (W31): navegação e menus, uma novidade por mudança visível.
  novidadeMenuLateral,
  novidadeIndices,
  novidadeCadastrosAbas,
  novidadeFinanceiroLinha,
  novidadeRelatoriosMenu,
  novidadeVersaoNoAr,
  // Portal do Cliente (Onda 1): convite, documentos, mensagens e "Ver como o cliente".
  novidadePortal,
  // Fase 2 (W30): WhatsApp com três provedores, escolhido por workspace.
  novidadeWhatsAppProvedores,
  // Fase 2 (W29): "Enviar cobrança agora" na ficha da fatura.
  novidadeEnviarCobranca,
  // Fase 2 (W28): cobrança pelo Asaas pronta para a operação.
  novidadeAsaas,
  // Fase 2 (W27): e-mails no padrão do ERP antigo e avisos de segurança da conta.
  novidadeEmails,
  // Fase 2 (W26): a agenda do Google de cada profissional ou recurso.
  novidadeAgendaGoogle,
  // Fase 2 (W25, K21 e K14): lixeira nas telas que faltavam e as condições do fornecedor na ficha.
  novidadeLixeiraFornecedor,
  // Fase 2 (W24, K9): cadastros contábeis e baixa.
  novidadeCadastrosContabeis,
  // Fase 2 (W23, K10 e K11): Criar tarefa a partir de um registro e o funcionário ligado a um fornecedor.
  novidadeTarefaRegistro,
  novidadeFuncionarioParceiro,
  // Fase 2 (W22, K8): avisos novos no sino, antecedência e exceções do membro.
  novidadeAvisos,
  novidadeMargem,
  novidadeInicioArremates,
  novidadeOutraEmpresa,
  // Fase 2 (W18): Agenda pelo catálogo de Serviços e importadores completos.
  novidadeAgendaServicos,
  novidadeFichaPessoas,
  novidadeVinculos,
  novidadeEquipe,
  novidadeLixeira,
  novidadeRelatorios,
  novidadeContratos,
  novidadeAssistentes,
  novidadeConversasEmail,
  novidadeTarefas,
  novidadeCompras,
  novidadeFinanceiro,
  novidadeCatalogos,
  novidadeCadastros,
  novidadeConta,
  novidadeNotificacoes,
  novidadeInicio,
];

export const novidadePorId = (id: string) => NOVIDADES.find((n) => n.id === id) ?? null;

/**
 * Novidades que esta pessoa ainda não viu: sem correção, publicadas depois que a conta dela existia, do módulo instalado
 * e com a permissão de ver.
 */
export function novidadesPendentes(
  lista: readonly Novidade[],
  p: { vistas: readonly string[]; usuarioCriadoEm: string | null; instalado: (slug: string) => boolean; pode: (permissao: string) => boolean },
): Novidade[] {
  const criado = p.usuarioCriadoEm?.slice(0, 10) ?? '';
  return lista.filter(
    (n) => n.tipo !== 'correcao' && !p.vistas.includes(n.id) && criado < n.publicada_em && (!n.modulo || p.instalado(n.modulo)) && (!n.permissao || p.pode(n.permissao)),
  );
}
